/**
 * in-demand-badge.js
 * --------------------
 * Reads the units-sold count off each <product-card> element's
 * data-in-demand-count attribute (set server-side in product-card.liquid,
 * which has direct access to `product`) and, if it's at or above the
 * threshold, injects a small badge onto that card's actual rendered
 * image — found at runtime, so it works no matter which generic block
 * (Image, Media, etc.) the merchant happened to use for that card.
 *
 * Runs once on page load, and again whenever new product cards get
 * added to the page later (collection filtering, infinite scroll, etc.)
 * via a MutationObserver.
 */

(function () {
  var THRESHOLD = 14;

  function injectStyles() {
    if (document.getElementById("in-demand-badge-styles")) return;
    var style = document.createElement("style");
    style.id = "in-demand-badge-styles";
    style.textContent = [
      ".in-demand-badge-js{",
      "position:absolute;left:50%;bottom:10px;transform:translateX(-50%);",
      "background:rgba(243,241,236,0.95);color:#141311;",
      "font-size:11.5px;font-weight:600;padding:6px 14px;",
      "border-radius:20px;white-space:nowrap;z-index:2;",
      "pointer-events:none;font-family:inherit;line-height:1;",
      "}",
      "@media screen and (max-width:749px){",
      ".in-demand-badge-js{",
      "font-size:9.5px;font-weight:600;padding:3px 9px;bottom:6px;",
      "border-radius:14px;",
      "}",
      "}",
    ].join("");
    document.head.appendChild(style);
  }

  function findImageWrapper(card) {
    var img = card.querySelector("img");
    if (!img) return null;

    // Prefer a known wrapper class if one is in the image's ancestry —
    // both .media-block and .image-block already set position: relative
    // in this theme, which is exactly what we need.
    var knownWrapper = img.closest(".media-block, .image-block");
    if (knownWrapper) return knownWrapper;

    // Fallback: use the image's direct parent and force relative
    // positioning on it ourselves.
    var parent = img.parentElement;
    if (parent && getComputedStyle(parent).position === "static") {
      parent.style.position = "relative";
    }
    return parent;
  }

  function addBadge(card) {
    if (card.dataset.inDemandApplied === "true") return;

    var count = parseInt(card.dataset.inDemandCount || "0", 10);
    if (!count || count < THRESHOLD) return;

    var wrapper = findImageWrapper(card);
    if (!wrapper) return;

    var badge = document.createElement("div");
    badge.className = "in-demand-badge-js";
    badge.textContent = "In Demand! " + count + " Bought";

    wrapper.appendChild(badge);
    card.dataset.inDemandApplied = "true";
  }

  function scan() {
    injectStyles();
    document
      .querySelectorAll("product-card[data-in-demand-count]")
      .forEach(addBadge);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Catch cards added later (filtering, sorting, infinite scroll).
  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
